import { logger } from '../logger';

/**
 * Logger for prospecting operations
 * Use this for prospect generation, scoring, and engagement
 */
const prospectLogger = logger.child('Prospect');

export default prospectLogger;
